import { entityPermissionList, userPermissionList } from "utils/constants"

export const publicRoutes = {
	login: {
		path: "/se-connecter",
	},
	activateAccount: {
		path: "/activer-mon-compte",
		search: "?token=:slug",
	},
	lostPassword: {
		path: "/mot-de-passe-perdu",
	},
	notFound: {
		path: "/page-introuvable",
	},
	// Create Bicycode Account
	// signup: {
	//     path: "/devenez-partenaire"
	// },
}

const anyEntity = entityPermissionList.map((e) => e.value)
const anyUser = userPermissionList.map((u) => u.value)
// TODO: if entitySpecificPermissionList has specific values, make an union of both permission arrays:
// const anyUser = [...new Set([
//         ...userPermissionList.map(u => u.value),
//         ...entitySpecificPermissionList.map(u => u.value)
//     ])]

export const privateRoutes = {
	// Global
	home: {
		path: "/accueil",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
	error: {
		path: "/error",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
	// success: {
	//     path: "/success",
	//     entityRoles: [],
	//     userRoles: [...anyUser]
	// },
	notAuthorized: {
		path: "/non-autorise",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
	// Bike
	bike: {
		path: "/rechercher-un-velo/:slug",
		basePath: "/rechercher-un-velo",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
	searchBike: {
		path: "/rechercher-un-velo",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
	updatedBike: {
		path: "/velo-mis-a-jour/:slug",
		basePath: "/velo-mis-a-jour",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
	bicytrust: {
		path: "/contrats-bicytrust",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
	// Partner / Shop
	team: {
		path: "/gestion-equipe",
		entityRoles: ["MANAGEBIKES"],
		userRoles: [...anyUser],
	},
	// Import bike files
	bikeCollectionImport: {
		path: "/import-velos",
		entityRoles: ["MANAGEBIKES"],
		userRoles: [...anyUser],
	},
	shop: {
		path: "/gestion-magasin",
		entityRoles: ["MANAGEBIKES"],
		userRoles: [...anyUser],
	},
	// Admin - partner enrolment
	addPartner: {
		path: "/ajouter-un-partenaire",
		entityRoles: ["MANAGEENTITIES"],
		userRoles: [...anyUser],
	},
	partner: {
		path: "/partenaires/:slug",
		basePath: "/partenaires",
		entityRoles: ["MANAGEENTITIES"],
		userRoles: [...anyUser],
	},
	teamPartner: {
		path: "/gestion-equipe-partenaire/:slug",
		basePath: "/gestion-equipe-partenaire",
		entityRoles: ["MANAGEENTITIES"],
		userRoles: [...anyUser],
	},
	validatedPartner: {
		path: "/partenaires",
		entityRoles: ["MANAGEENTITIES"],
		userRoles: [...anyUser],
	},
	validatePartner: {
		path: "/valider-dossier",
		entityRoles: ["MANAGEENTITIES"],
		userRoles: [...anyUser],
	},
	searchUser: {
		path: "/rechercher-un-utilisateur",
		entityRoles: ["MANAGEENTITIES"],
		userRoles: [...anyUser],
	},
	// Contact
	contact: {
		path: "/contact",
		entityRoles: ["MANAGEBIKES"],
		userRoles: [...anyUser],
	},
	// History
	history: {
		path: "/historique-des-marquages",
		entityRoles: ["MANAGEBIKES"],
		userRoles: [...anyUser],
	},
	// Admin
	manageAdmin: {
		path: "/gestion-administrateurs",
		entityRoles: ["MANAGEENTITIES"],
		userRoles: [...anyUser],
	},
	bikeFleet: {
		path: "/gestion-de-flotte",
		entityRoles: ["MANAGEBIKES"],
		userRoles: [...anyUser],
	},
	bikeLabelOrder: {
		path: "/commande-etiquettes",
		entityRoles: [...anyEntity],
		userRoles: [...anyUser],
	},
}
